import { render, staticRenderFns } from "./VehicleSelect.vue?vue&type=template&id=86372bc2&"
import script from "./VehicleSelect.vue?vue&type=script&lang=js&"
export * from "./VehicleSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports